<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
    <form class="kt-form w-webkit-fill-available" [formGroup]="form">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Create Reconciliation Job</h5>
                <span class="modal-x-button" (click)="onCloseDialog()">
                    <i class="fa fa-times" aria-hidden="true"></i>
                </span>
            </div>
            <div class="modal-body">
                <div class="col-12 form-group row">
                    <label class="col-4 col-form-label">Transaction Timestamp<span class="text-danger">*</span><i class="fa fa-info-circle ml-1" placement="bottom" [ngbTooltip]="dateToolTip" tooltipClass="tooltip-class"></i></label>
                    <div class="col-8 input-group date">
                        <input type="text" class="form-control" formControlName="defaultDate" [timePicker]="false" [timePickerSeconds]="false" [opens]="'left'"  [alwaysShowCalendars]="false" [ranges]="ranges" [showCustomRangeLabel]="true" [locale]="{format: 'YYYY-MM-DD HH:mm:ss'}" [timePicker24Hour]="true" [showDropdowns]="true" ngxDaterangepickerMd/>
                    </div>
                </div>
                <ng-template #dateToolTip>
                    <div class="text-left">
                        The transaction timestamp will apply for payment gateway's transaction filtered by transaction datetime and data from BO 7.2 filtered by "Created Date".
                    </div>
                </ng-template>
                <div class="col-12 form-group row">
                    <label class="col-4 control-label">Currency</label>
                    <div class="col-8" style="padding:0">
                        <select formControlName="currency_code" class="form-control">
                            <option value="">All</option>
                            <option [value]="currency" *ngFor="let currency of currencies">{{ currency }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 form-group row">
                    <label class="col-4 control-label">Payment Gateway Account<span class="text-danger">*</span></label>
                    <kt-dropdown-wo-lazyload class="dropdown-maxheight col-8 merchant-bank-list" style="padding:0"
                        [form] = 'form'
                        [dropdownList] = 'paymentGatewayDropdownList'
                        [dropdownSettings] = 'paymentGatewayDropdownSettings'
                        [formName] = "'pg_bot_id'"
                        [selectionAttributes] = "'id'"
                        [selectedItems] = 'paymentGatewaySelectedItems'
                        [dataLoading] = 'paymentGatewayAccountLoading'>
                    </kt-dropdown-wo-lazyload>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="onCloseDialog()"><i class="fas fa-ban"></i>Close</button>
                <kt-submit-button *ngIf="canCreateReconciliationJob" [isDisabled]="!form.valid" [buttonLoading]="buttonLoading" (confirmed)="onSave()"></kt-submit-button>
            </div>
        </div>
    </form>
</div>
<kt-swal-alert [message]="messages$ | async" (confirmed)="onCloseDialog(true)"></kt-swal-alert>
